<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      {{ createNew ? 'New' : 'Edit' }}
      Checklist Template Category
    </template>

    <template #body>
      <SubSection>
        <template #body>
          <VeeForm v-if="selectedCategory" @submit="onSubmit">
            <div class="row">
              <TextInput v-model="selectedCategory.categoryName" name="categoryName" label="Category Name"
                rules="required" col-style="form-group-standard-column" />
            </div>
            <ActionToolbar :component-state="currentState" 
              :success-message="successMessage" 
              :error-message="formError" 
              :secondary-button-text="createNew ? 'Cancel' : 'Close'"
              @secondary-click="cancel" />
          </VeeForm>
        </template>
      </SubSection>
    </template>
  </CardSection>
</template>

<script lang="ts">
import CardSection from "@/src/components/shared/CardSection.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import { useChecklistStore } from '@/src/stores/checklist';
import SubSection from "@/src/components/shared/SubSection.vue";
import '@/src/vee-validate.js';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import MultiSelectInput from "@/src/components/shared/FormComponents/MultiSelectInput.vue";
import TextInput from "@/src/components/shared/FormComponents/TextInput.vue";
import { Form as VeeForm } from 'vee-validate';

export default {
  components: {
    CardSection,
    SubSection,
    ActionToolbar,
    MultiSelectInput,
    TextInput,
    VeeForm
  },
  mixins: [ savableStateMixin ],
  setup() {
    const checklistStore = useChecklistStore();
    return { checklistStore };
  },
  data() {
    return {
      selectedCategory: null,
      successMessage: null
    }
  },
  computed: {
    createNew() {
      return this.$route.params.id ? false : true;
    }
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      this.selectedCategory = {};
      if(!this.createNew) {
        const record = await this.checklistStore.loadCategory(this.$route.params.id);
        this.loadForm(record.data);
      }
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error);
    }
  },
  methods: {
    async onSubmit() {
      this.setSavableStateProcessing();
      const payload = {
        category_name: this.selectedCategory.categoryName,
        id: null
      }
      try {
        if (this.createNew) {
          const response = await this.checklistStore.createCategory(payload)
          this.successMessage = 'Successfully created!'
          this.$router.push({ name: 'admin_checklist_template_categories_edit', params: { id: response.data.id }});
          this.loadForm(response.data);
        } else {
          payload.id = this.selectedCategory.id;
          const response = await this.checklistStore.updateCategory(payload)
          this.successMessage = 'Successfully updated!'
          this.loadForm(response.data);
        }
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    loadForm(record) {
      this.selectedCategory = {
        id: record.id,
        categoryName: record.category_name
      };
    },
    cancel() {
      this.$router.push({ name: 'admin_checklist_template_categories' });
    }
  }
}
</script>